import { render, staticRenderFns } from "./LoginWithOtp.vue?vue&type=template&id=1b45c7f6&"
import script from "./LoginWithOtp.vue?vue&type=script&lang=js&"
export * from "./LoginWithOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports